import { buildingTypes } from "../data/select-data";
import { EBuildingType, EOfferRequestType } from "../enums";
import { EInputType, IInputFieldItem } from "../components/UI/Input/Input";
import { ETranslation } from "../translations/translation-keys";

export const provinceOptions = [
  { value: "Ahvenanmaa", label: "Ahvenanmaa" },
  { value: "Etelä-Karjala", label: "Etelä-Karjala" },
  { value: "Etelä-Pohjanmaa", label: "Etelä-Pohjanmaa" },
  { value: "Etelä-Savo", label: "Etelä-Savo" },
  { value: "Kainuu", label: "Kainuu" },
  { value: "Kanta-Häme", label: "Kanta-Häme" },
  { value: "Keski-Pohjanmaa", label: "Keski-Pohjanmaa" },
  { value: "Keski-Suomi", label: "Keski-Suomi" },
  { value: "Kymenlaakso", label: "Kymenlaakso" },
  { value: "Lappi", label: "Lappi" },
  { value: "Pirkanmaa", label: "Pirkanmaa" },
  { value: "Pohjanmaa", label: "Pohjanmaa" },
  { value: "Pohjois-Karjala", label: "Pohjois-Karjala" },
  { value: "Pohjois-Pohjanmaa", label: "Pohjois-Pohjanmaa" },
  { value: "Pohjois-Savo", label: "Pohjois-Savo" },
  { value: "Päijät-Häme", label: "Päijät-Häme" },
  { value: "Satakunta", label: "Satakunta" },
  { value: "Uusimaa", label: "Uusimaa" },
  { value: "Varsinais-Suomi", label: "Varsinais-Suomi" },
];

export const finnishMunicipalities = [
  "Akaa", "Alajärvi", "Alavieska", "Alavus", "Asikkala", "Askola", "Aura",
  "Brändö",
  "Eckerö", "Enonkoski", "Enontekiö", "Espoo", "Eura", "Eurajoki", "Evijärvi",
  "Finström", "Forssa", "Föglö",
  "Geta",
  "Haapajärvi", "Haapavesi", "Hailuoto", "Halsua", "Hamina", "Hammarland", "Hankasalmi", "Hanko", "Harjavalta", "Hartola", "Hattula", "Hausjärvi", "Heinola", "Heinävesi", "Helsinki", "Hirvensalmi", "Hollola", "Huittinen", "Humppila", "Hyrynsalmi", "Hyvinkää", "Hämeenkyrö", "Hämeenlinna",
  "Ii", "Iisalmi", "Iitti", "Ikaalinen", "Ilmajoki", "Ilomantsi", "Imatra", "Inari", "Inkoo", "Isojoki", "Isokyrö",
  "Janakkala", "Joensuu", "Jokioinen", "Jomala", "Joroinen", "Joutsa", "Juuka", "Juupajoki", "Juva", "Jyväskylä", "Jämijärvi", "Jämsä", "Järvenpää",
  "Kaarina", "Kaavi", "Kajaani", "Kalajoki", "Kangasala", "Kangasniemi", "Kankaanpää", "Kannonkoski", "Kannus", "Karijoki", "Karkkila", "Karstula", "Karvia", "Kaskinen", "Kauhajoki", "Kauhava", "Kauniainen", "Kaustinen", "Keitele", "Kemi", "Kemijärvi", "Keminmaa", "Kemiönsaari", "Kempele", "Kerava", "Keuruu", "Kihniö", "Kinnula", "Kirkkonummi", "Kitee", "Kittilä", "Kiuruvesi", "Kivijärvi", "Kokemäki", "Kokkola", "Kolari", "Konnevesi", "Kontiolahti", "Korsnäs", "Koski Tl", "Kotka", "Kouvola", "Kristiinankaupunki", "Kruunupyy", "Kuhmo", "Kuhmoinen", "Kumlinge", "Kuopio", "Kuortane", "Kurikka", "Kustavi", "Kuusamo", "Kyyjärvi", "Kärkölä", "Kärsämäki", "Kökar",
  "Lahti", "Laihia", "Laitila", "Lapinjärvi", "Lapinlahti", "Lappajärvi", "Lappeenranta", "Lapua", "Laukaa", "Lemi", "Lemland", "Lempäälä", "Leppävirta", "Lestijärvi", "Lieksa", "Lieto", "Liminka", "Liperi", "Lohja", "Loimaa", "Loppi", "Loviisa", "Luhanka", "Lumijoki", "Lumparland", "Luumäki",
  "Maalahti", "Maarianhamina", "Marttila", "Masku", "Merijärvi", "Merikarvia", "Miehikkälä", "Mikkeli", "Muhos", "Multia", "Muonio", "Mustasaari", "Muurame", "Mynämäki", "Myrskylä", "Mäntsälä", "Mänttä-Vilppula", "Mäntyharju",
  "Naantali", "Nakkila", "Nivala", "Nokia", "Nousiainen", "Nurmes", "Nurmijärvi", "Närpiö",
  "Orimattila", "Oripää", "Orivesi", "Oulainen", "Oulu", "Outokumpu",
  "Padasjoki", "Paimio", "Paltamo", "Parainen", "Parikkala", "Parkano", "Pedersöre", "Pelkosenniemi", "Pello", "Perho", "Petäjävesi", "Pieksämäki", "Pielavesi", "Pietarsaari", "Pihtipudas", "Pirkkala", "Polvijärvi", "Pomarkku", "Pori", "Pornainen", "Porvoo", "Posio", "Pudasjärvi", "Pukkila", "Punkalaidun", "Puolanka", "Puumala", "Pyhtää", "Pyhäjoki", "Pyhäjärvi", "Pyhäntä", "Pyhäranta", "Pälkäne", "Pöytyä",
  "Raahe", "Raasepori", "Raisio", "Rantasalmi", "Ranua", "Rauma", "Rautalampi", "Rautavaara", "Rautjärvi", "Reisjärvi", "Riihimäki", "Ristijärvi", "Rovaniemi", "Ruokolahti", "Ruovesi", "Rusko", "Rääkkylä",
  "Saarijärvi", "Salla", "Salo", "Saltvik", "Sastamala", "Sauvo", "Savitaipale", "Savonlinna", "Savukoski", "Seinäjoki", "Sievi", "Siikainen", "Siikajoki", "Siikalatva", "Siilinjärvi", "Simo", "Sipoo", "Siuntio", "Sodankylä", "Soini", "Somero", "Sonkajärvi", "Sotkamo", "Sottunga", "Sulkava", "Sund", "Suomussalmi", "Suonenjoki", "Sysmä", "Säkylä",
  "Taipalsaari", "Taivalkoski", "Taivassalo", "Tammela", "Tampere", "Tervo", "Tervola", "Teuva", "Tohmajärvi", "Toholampi", "Toivakka", "Tornio", "Turku", "Tuusniemi", "Tuusula", "Tyrnävä",
  "Ulvila", "Urjala", "Utajärvi", "Utsjoki", "Uurainen", "Uusikaarlepyy", "Uusikaupunki",
  "Vaala", "Vaasa", "Valkeakoski", "Vantaa", "Varkaus", "Vehmaa", "Vesanto", "Vesilahti", "Veteli", "Vieremä", "Vihti", "Viitasaari", "Vimpeli", "Virolahti", "Virrat", "Vårdö", "Vöyri",
  "Ylitornio", "Ylivieska", "Ylöjärvi", "Ypäjä",
  "Ähtäri", "Äänekoski"
];

export const municipalityOptions = finnishMunicipalities.map((name) => ({
  value: name,
  label: name,
}));

export interface IDynamicField extends Omit<IInputFieldItem, "value"> {
  name: string;
  condition?: (inputs: any) => boolean;
}

export const dynamicForms: Record<string, IDynamicField[]> = {
  [EOfferRequestType.CONSTRUCTION]: [
    {
      name: "area",
      type: EInputType.text,
      labelTranslation: ETranslation.OFFER_REQUEST_CONSTRUCTION_AREA,
      placeholderTranslation: ETranslation.OFFER_REQUEST_CONSTRUCTION_AREA,
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      labelTranslation:
        ETranslation.OFFER_REQUEST_CONSTRUCTION_CONSTRUCTION_YEAR,
      placeholderTranslation:
        ETranslation.OFFER_REQUEST_CONSTRUCTION_CONSTRUCTION_YEAR,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_CONSTRUCTION_BUILDING_TYPE,
      placeholderTranslation:
        ETranslation.OFFER_REQUEST_CONSTRUCTION_BUILDING_TYPE,
      isClearable: true,
      options: buildingTypes,
    },
    {
      name: "buildingTypeOther",
      type: EInputType.text,
      labelTranslation:
        ETranslation.OFFER_REQUEST_CONSTRUCTION_BUILDING_TYPE_OTHER,
      placeholderTranslation:
        ETranslation.OFFER_REQUEST_CONSTRUCTION_BUILDING_TYPE_OTHER,
      condition: (inputs) =>
        inputs["buildingType"]?.value === EBuildingType.OTHER,
    },
  ],
  [EOfferRequestType.WELLNESS]: [
    {
      name: "length",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_WELLNESS_LENGTH,
      placeholderTranslation: ETranslation.OFFER_REQUEST_WELLNESS_LENGTH,
      isClearable: true,
      options: [],
    },
    {
      name: "regular",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_WELLNESS_REGULAR,
      placeholderTranslation: ETranslation.OFFER_REQUEST_WELLNESS_REGULAR,
    },
  ],
  hankiaurinkopaneeli: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Asennuskohde",
      options: [
        { value: "Katto (Omakotitalo)", label: "Katto (Omakotitalo)" },
        { value: "Maa-asennus", label: "Maa-asennus" },
        { value: "Vapaa-ajan asunto", label: "Vapaa-ajan asunto" },
        { value: "Yritys/Maatila", label: "Yritys/Maatila" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "roofType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Kattomateriaali",
      options: [
        { value: "Pelti", label: "Pelti" },
        { value: "Tiili", label: "Tiili" },
        { value: "Huopa", label: "Huopa" },
        { value: "Muu/Ei tiedossa", label: "Muu/Ei tiedossa" },
      ],
    },
    {
      name: "consumption",
      type: EInputType.text,
      label: "Vuosikulutus (kWh)",
    },
  ],
  hankitiiveysmittaus: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Koti", label: "Koti" },
        { value: "Toimisto", label: "Toimisto" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "area",
      type: EInputType.text,
      label: "Pinta-ala",
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi",
    },
    {
      name: "acceptTerms",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_ACCEPT_TERMS,
    },
  ],
  hankikuntotarkastus: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Paritalo", label: "Paritalo" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Erillistalo", label: "Erillistalo" },
        { value: "Kerrostalo", label: "Kerrostalo" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "area",
      type: EInputType.text,
      label: "Pinta-ala (m²)",
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi",
    },
    {
      name: "acceptTerms",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_ACCEPT_TERMS,
    },
  ],
  hankilampokuvaus: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Paritalo", label: "Paritalo" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Erillistalo", label: "Erillistalo" },
        { value: "Kerrostalo", label: "Kerrostalo" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "area",
      type: EInputType.text,
      label: "Pinta-ala (m²)",
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi",
    },
    {
      name: "purpose",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Lämpökuvauksen syy",
      options: [
        { value: "Vedon tunne tai kylmyys", label: "Vedon tunne tai kylmyys" },
        { value: "Korkea energiankulutus", label: "Korkea energiankulutus" },
        { value: "Laadunvarmistus remontin/rakentamisen jälkeen", label: "Laadunvarmistus remontin/rakentamisen jälkeen" },
        { value: "Asuntokauppa", label: "Asuntokauppa" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "acceptTerms",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_ACCEPT_TERMS,
    },
  ],
  hankikosteusmittaus: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Paritalo", label: "Paritalo" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Erillistalo", label: "Erillistalo" },
        { value: "Kerrostalo", label: "Kerrostalo" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "area",
      type: EInputType.text,
      label: "Pinta-ala (m²)",
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi",
    },
    {
      name: "purpose",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Kosteusmittauksen syy",
      options: [
        { value: "Asuntokauppa", label: "Asuntokauppa" },
        { value: "Kylpyhuoneremontti", label: "Kylpyhuoneremontti" },
        { value: "Epäily vesivahingosta tai homeesta", label: "Epäily vesivahingosta tai homeesta" },
        { value: "Tarkastus ennen muuttoa", label: "Tarkastus ennen muuttoa" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "acceptTerms",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_ACCEPT_TERMS,
    },
  ],
  varaakaupanvahvistaja: [
    {
      name: "city",
      type: EInputType.text,
      label: "Paikkakunta, missä kaupat tehdään",
    },
    {
      name: "transactionType",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_KAUPAN_LUONNE,
      isClearable: true,
      options: [
        {
          value: "Kiinteistö- tai tonttikauppa",
          label: "Kiinteistö- tai tonttikauppa",
        },
        { value: "Lahjakirja", label: "Lahjakirja" },
        { value: "Vaihtokirja", label: "Vaihtokirja" },
        {
          value: "Muu ositus tai asiakirja",
          label: "Muu ositus tai asiakirja",
        },
      ],
    },
    {
      name: "schedule",
      type: EInputType.datetimepicker,
      labelTranslation: ETranslation.OFFER_REQUEST_TOIVOTTU_AJANKOHTA,
    },
    {
      name: "additionalInfo",
      type: EInputType.textarea,
      label: "Lisätiedot (Esim. pankin konttori)",
    },
  ],
  hankienergiatodistus: [
    {
      name: "municipality",
      type: EInputType.text,
      labelTranslation: ETranslation.OFFER_REQUEST_ENERGIATODISTUS_MUNICIPALITY,
    },
    {
      name: "type",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_ENERGIATODISTUS_TYPE,
      isClearable: true,
      options: [
        { value: "EXISTING", label: "Olemassa oleva rakennus" },
        { value: "NEW", label: "Uusi rakennus" },
      ],
    },
    {
      name: "completionYear",
      type: EInputType.text,
      labelTranslation:
        ETranslation.OFFER_REQUEST_CONSTRUCTION_CONSTRUCTION_YEAR,
    },
    {
      name: "buildingCategory",
      type: EInputType.reactSelect,
      labelTranslation:
        ETranslation.OFFER_REQUEST_ENERGIATODISTUS_BUILDING_CATEGORY,
      isClearable: true,
      isSearchable: true,
      options: [
        { value: "Asuinkerrostalo", label: "Asuinkerrostalo" },
        { value: "Hirsitalo", label: "Hirsitalo" },
        { value: "Jäähalli", label: "Jäähalli" },
        { value: "Ketjutalo", label: "Ketjutalo" },
        { value: "Liikerakennus", label: "Liikerakennus" },
        { value: "Majoitusliikerakennus", label: "Majoitusliikerakennus" },
        { value: "Muu rakennus", label: "Muu rakennus" },
        { value: "Määräaikainen rakennus", label: "Määräaikainen rakennus" },
        { value: "Opetusrakennus", label: "Opetusrakennus" },
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Pientalo", label: "Pientalo" },
        { value: "Päiväkoti", label: "Päiväkoti" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Sairaala", label: "Sairaala" },
        { value: "Toimistorakennus", label: "Toimistorakennus" },
        { value: "Uimahalli", label: "Uimahalli" },
      ],
    },
    {
      name: "region",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "apartmentAmount",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_ENERGIATODISTUS_APARTMENTS,
      isClearable: true,
      options: [
        { value: "1-2", label: "1-2" },
        { value: "3-6", label: "3-6" },
        { value: "6+", label: "yli 6" },
      ],
    },
    {
      name: "warmApartments",
      type: EInputType.text,
      labelTranslation:
        ETranslation.OFFER_REQUEST_ENERGIATODISTUS_HEATED_BUILDINGS,
    },
    {
      name: "area",
      type: EInputType.text,
      labelTranslation: ETranslation.OFFER_REQUEST_CONSTRUCTION_AREA,
    },
    {
      name: "heating",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_ENERGIATODISTUS_HEATING,
      isClearable: true,
      options: [
        { value: "Kaukolämpö", label: "Kaukolämpö" },
        { value: "Öljylämmitys", label: "Öljylämmitys" },
        { value: "Maalämpö", label: "Maalämpö" },
        { value: "Sähkö", label: "Sähkö" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "ventilation",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_ENERGIATODISTUS_VENTILATION,
      isClearable: true,
      options: [
        { value: "Jäähdytys", label: "Jäähdytys" },
        { value: "Suodatus", label: "Suodatus" },
        { value: "Ilmanvaihto", label: "Ilmanvaihto" },
      ],
    },
    {
      name: "dueDate",
      type: EInputType.datepicker,
      labelTranslation: ETranslation.OFFER_REQUEST_ENERGIATODISTUS_DUE_DATE,
    },
  ],
  ilmatiiveysmittaus: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Koti", label: "Koti" },
        { value: "Toimisto", label: "Toimisto" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "area",
      type: EInputType.text,
      label: "Pinta-ala",
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi",
    },
    {
      name: "acceptTerms",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_ACCEPT_TERMS,
    },
  ],
  hankiasbestikartoitus: [
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Kerrostalo", label: "Kerrostalo" },
        { value: "Liiketila", label: "Liiketila" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi (ennen 1994)",
    },
    {
      name: "urgency",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Kiireellisyys",
      options: [
        { value: "Heti (alle 1 vk)", label: "Heti (alle 1 vk)" },
        { value: "1-2 viikon sisällä", label: "1-2 viikon sisällä" },
        { value: "Kuukauden sisällä", label: "Kuukauden sisällä" },
        { value: "Ei kiirettä", label: "Ei kiirettä" },
      ],
    },
  ],
  radonmittaus: [
    {
      name: "customerType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Asiakastyyppi",
      options: [
        { value: "Yksityishenkilö", label: "Yksityishenkilö" },
        { value: "Yritys/Työnantaja", label: "Yritys/Työnantaja" },
        { value: "Taloyhtiö", label: "Taloyhtiö" },
      ],
    },
    {
      name: "serviceRequired",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Tarvittava palvelu",
      options: [
        { value: "Purkkimittaus postitse", label: "Purkkimittaus postitse" },
        { value: "Ammattilaisen kartoituskäynti", label: "Ammattilaisen kartoituskäynti" },
        { value: "Radonkorjaus (remontti)", label: "Radonkorjaus (remontti)" },
      ],
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Kerrostalo/Kellaritila", label: "Kerrostalo/Kellaritila" },
        { value: "Liike- tai toimistotila", label: "Liike- tai toimistotila" },
        { value: "Muu", label: "Muu" },
      ],
    },
  ],
  hankiilmanvaihdonhuolto: [
    {
      name: "province",
      type: EInputType.reactSelect,
      labelTranslation: ETranslation.OFFER_REQUEST_PROVINCE,
      isClearable: true,
      isSearchable: true,
      options: provinceOptions,
    },
    {
      name: "buildingType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Rakennustyyppi",
      options: [
        { value: "Omakotitalo", label: "Omakotitalo" },
        { value: "Paritalo", label: "Paritalo" },
        { value: "Rivitalo", label: "Rivitalo" },
        { value: "Erillistalo", label: "Erillistalo" },
        { value: "Kerrostalo", label: "Kerrostalo" },
        { value: "Muu", label: "Muu" },
      ],
    },
    {
      name: "area",
      type: EInputType.text,
      label: "Pinta-ala (m²)",
    },
    {
      name: "constructionYear",
      type: EInputType.text,
      label: "Rakennusvuosi",
    },
    {
      name: "systemType",
      type: EInputType.reactSelect,
      isClearable: true,
      label: "Ilmanvaihtojärjestelmä",
      options: [
        { value: "Koneellinen tulo- ja poisto", label: "Koneellinen tulo- ja poisto" },
        { value: "Koneellinen poisto", label: "Koneellinen poisto" },
        { value: "Painovoimainen", label: "Painovoimainen" },
        { value: "En tiedä", label: "En tiedä" },
      ],
    },
    {
      name: "acceptTerms",
      type: EInputType.checkbox,
      labelTranslation: ETranslation.OFFER_REQUEST_ACCEPT_TERMS,
    },
  ],
};

export const getDynamicFieldsForService = (
  serviceToken?: string,
  serviceType?: string,
): IDynamicField[] => {
  if (serviceToken && dynamicForms[serviceToken]) {
    return dynamicForms[serviceToken];
  }
  if (serviceType && dynamicForms[serviceType]) {
    return dynamicForms[serviceType];
  }
  return [];
};
